import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { schedulesStateSelector } from "./schedulesStateSelector";

export const currentWorkflowSelector = createDraftSafeSelector(
  [schedulesStateSelector],
  (schedules) => schedules.workflow,
);
